export default __webpack_public_path__ + "202851c47c628712c7f06176d5dd50a6.svg";